import Api, { baseURL } from "./Api"

const BASE = `${baseURL("v2")}/{departamento}/usuarios-geos`

export default {
  list() {
    return Api.get(BASE)
  },
  show(id, params) {
    return Api.get(`${BASE}/${id}/historicos`, params)
  },
}
